var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66797C5.40866 1.66797 1.66699 5.40964 1.66699 10.0013C1.66699 14.593 5.40866 18.3346 10.0003 18.3346C14.592 18.3346 18.3337 14.593 18.3337 10.0013C18.3337 5.40964 14.592 1.66797 10.0003 1.66797ZM13.9837 8.08464L9.25866 12.8096C9.14199 12.9263 8.98366 12.993 8.81699 12.993C8.65033 12.993 8.49199 12.9263 8.37533 12.8096L6.01699 10.4513C5.77533 10.2096 5.77533 9.80964 6.01699 9.56797C6.25866 9.3263 6.65866 9.3263 6.90033 9.56797L8.81699 11.4846L13.1003 7.2013C13.342 6.95964 13.742 6.95964 13.9837 7.2013C14.2253 7.44297 14.2253 7.83464 13.9837 8.08464Z",
    fill: "#2E9E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleIcon);
export default __webpack_public_path__ + "static/media/tick-circle-icon.590813e74c21c15a5fdd492be307e816.svg";
export { ForwardRef as ReactComponent };